export function parseCount(v) {
  if (v == null) return 0;
  const s = String(v).trim().toUpperCase().replace(/,/g, "");
  const num = parseFloat(s);
  if (Number.isNaN(num)) return 0;
  if (s.includes("M")) return num * 1_000_000;
  if (s.includes("K")) return num * 1_000;
  return num;
}

export function formatCount(n) {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(n % 1_000_000 === 0 ? 0 : 1)}M`;
  if (n >= 1_000) return `${Math.round(n / 1_000)}K`;
  return `${n}`;
}

export function totalFollowers(list) {
  return (list || []).reduce((sum, s) => sum + parseCount(s.followers), 0);
}

export const DEFAULT_SOCIALS = [
  { platform: "instagram", label: "ThatCreditCardGuy", url: "https://instagram.com/thatcreditcardguy", followers: "120K", image: "" },
  { platform: "instagram", label: "AlyHajiani", url: "https://instagram.com/alyhajiani", followers: "45K", image: "" },
  { platform: "youtube", label: "AlyHajiani", url: "https://youtube.com/@alyhajiani", followers: "30K", image: "" },
  { platform: "linkedin", label: "Aly Hajiani", url: "https://linkedin.com/in/alyhajiani", followers: "15K", image: "" },
  { platform: "x", label: "Definitaly", url: "https://x.com/definitaly", followers: "8K", image: "" },
];

export function resolveFollowersDisplay(settings) {
  const list = settings.social_links && settings.social_links.length ? settings.social_links : DEFAULT_SOCIALS;
  const auto = totalFollowers(list);
  const raw = settings.followers_total != null ? String(settings.followers_total).trim() : "";
  let numeric = auto;
  let animatable = true;
  let value = formatCount(auto);
  if (raw) {
    if (/^\d+$/.test(raw)) {
      numeric = parseInt(raw, 10);
      value = formatCount(numeric);
    } else {
      animatable = false;
      value = raw;
    }
  }
  const label = settings.followers_label || "Aggregated following";
  return { value, label, list, numeric, animatable };
}
